<div class="indicator-container avitium-bg-color rounded-circle" [ngClass]="{'top-right' : !position, position : position, 'size40' : size40, 'size30': size30}" [ngStyle]="{ 'margin-top': marginTop, 'margin-left': marginLeft, width, height, 'margin-right': marginRight }">
  <div class="indicator-text">
    {{text}}
  </div>
</div>
